/*
 * File: d:\projects\AutoFiFront\src\Content\BuyBack\Picture\Picture.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 24th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 24th 2023 10:37:00 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from "react";
import styles from "Content/BuyBack/Picture/Picture.module.css";
import ImageUpload from "Content/BuyBack/ImageUpload/ImageUpload";
import Form from 'react-bootstrap/Form';
import { PictureProps } from "Content/BuyBack/Picture/Picture.type";

function Picture(props: PictureProps) {
    return (
        <React.Fragment>
            <Form.Group className={`${styles.inputGroup} ${props.className}`} controlId={props.controlId}>
                <div className={styles.inputPicture}>
                    <ImageUpload className={`${styles.input}`} file={props.file} inputId={props.inputId} required={props.required} onChange={props.onChange} />
                    <Form.Label className={`${styles.title}`}>{props.pictureTitle}</Form.Label>
                </div>
            </Form.Group>
        </React.Fragment>
    );
}

export default Picture;
